<template>
  <Header />
  <article>
    <div class="kv">
      <div class="caption">
        <h1>在地部落共好</h1>
      </div>
    </div>
    <section class="sect1">
      <div class="ctx">
        <div>和平電廠位在花蓮最北邊的和平村，和宜蘭澳花村僅有一橋之隔，2002 年電廠完工啟用後，許多員工甚或外包商團隊都是當地和平或澳花部落的居民，電廠與部落有著 20 年以上的情誼，像是生命共同體、共生共好。</div>
        <p>和平電力每年提供在地和平國小、澳花國小獎助學金，鼓勵偏鄉孩童積極向學。</p>
        <br>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer1-1"></div>
          </div>
          <div class="right">
            <div class="imgContainer1-2"></div>
            <div class="imgContainer1-3"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect2">
      <div class="ctx">
        <div class="sectTit">和電宅配修</div>
        <p>澳花部落位於宜蘭最南端，考慮部落位處偏僻，居家水電修繕不易，和平電力以自身機電專業成立居家修繕團隊，適時協助部落水電修繕，改善其生活及居住環境。</p>
        <br>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer2-1"></div>
          </div>
          <div class="middle">
            <div class="imgContainer2-2"></div>
          </div>
          <div class="right">            
            <div class="imgContainer2-3"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="sect3">
      <div class="ctx">
        <div class="sectTit">延續廠內資源的循環利用</div>
        <p>電廠為了維持機組順暢運作，每年會進行年度歲修及設備汰除，當中許多資源設備拆除後都具有再利用的價值，和平電力也固定將設備整理後運送給有需要的在地村民。</p>
        <br>
        <div class="gallery">
          <div class="left">
            <div class="imgContainer3-1"></div>
            <div class="imgContainer3-2"></div>
            <div class="imgContainer3-3"></div>
          </div>
          <div class="right">            
            <div class="imgContainer3-4"></div>
            <div class="imgContainer3-5"></div>
            <div class="imgContainer3-6"></div>
          </div>
        </div>
      </div>
    </section>
  </article>
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import { ImgContainerAutoResize } from '../../util/util';
import Header from '../../components/Header.vue';
import Footer from '../../components/Footer.vue';

export default defineComponent({
  name: 'SocialTribe',
  components: {
    Header,
    Footer
  },
  data() {
    return {
    }
  },
  methods:{
  },
  mounted() {
    new ImgContainerAutoResize(document.querySelector(".kv") as HTMLElement, 0.368);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-1") as HTMLElement, 1);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-2") as HTMLElement, 0.74);
    new ImgContainerAutoResize(document.querySelector(".imgContainer1-3") as HTMLElement, 0.74);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-1") as HTMLElement, 1.2);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-2") as HTMLElement, 1.2);
    new ImgContainerAutoResize(document.querySelector(".imgContainer2-3") as HTMLElement, 1.2);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-1") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-2") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-3") as HTMLElement, 0.65);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-4") as HTMLElement, 0.855);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-5") as HTMLElement, 0.87);
    new ImgContainerAutoResize(document.querySelector(".imgContainer3-6") as HTMLElement, 0.87);
  }
});
</script>

<style>
.kv {
  height: 700px;
  position: relative;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0.5) 0, rgba(0, 0, 0, 0) 20%), url("@/assets/socialTribe/kv.webp");
  background-position: center, center bottom;
  background-size: cover, cover;
}

.kv .caption {
  width: 1200px;
  margin: 0 auto;
  padding: 25px 0;
  box-sizing: border-box;
}

.kv .caption h1 {
  margin: 0;
  display: inline-block;
  letter-spacing: 5px;
  font-weight: bold;
  font-size: 52px;
  color: #fff;
  text-shadow: 5px 5px 5px #00000066;
}
 

.sect1 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  overflow: hidden;
  border-radius: 30px;
}

.sect1 .gallery .left {
  flex: 0 0 59.5%;
}

.sect1 .gallery .right {
  flex: 0 0 40%;
}

.sect1 .gallery .left .imgContainer1-1 {
  background: url(@/assets/socialTribe/pic1_01.jpg) center;
  background-size: cover;
}

.sect1 .gallery .right .imgContainer1-2 {
  width: 100%;
  margin: 0 0 5px;
  background: url(@/assets/socialTribe/pic1_02.jpg) left center;
  background-size: cover;
}

.sect1 .gallery .right .imgContainer1-3 {
  width: 100%;
  background: url(@/assets/socialTribe/pic1_03.jpg) center;
  background-size: cover;
}

.sect2 {
  background: #63BFAA;
}

.sect2 .sectTit {
  width: 300px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  position: absolute;
  top: -35px;
  left: 0;
  right: 0;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #63BFAA;
  background: #F4F3F3;
}

.sect2 p {
  line-height: 2em;
  color: #fff;
}

.sect2 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
}

.sect2 .gallery .left {
  flex: 0 0 32%;  
}

.sect2 .gallery .left .imgContainer2-1 {
  width: 100%;
  border-radius: 30px;
  background: url(@/assets/socialTribe/pic2_01.jpg) center;
  background-size: cover;
}

.sect2 .gallery .middle {
  flex: 0 0 32%;
}

.sect2 .gallery .middle .imgContainer2-2 {
  width: 100%;
  border-radius: 30px;
  background: url(@/assets/socialTribe/pic2_02.jpg) center;
  background-size: cover;
}

.sect2 .gallery .right {
  flex: 0 0 32%;
}

.sect2 .gallery .right .imgContainer2-3 {
  width: 100%;
  border-radius: 30px;
  background: url(@/assets/socialTribe/pic2_03.jpg) center;
  background-size: cover;
}

.sect3 {
  background: url(@/assets/socialTribe/sectBack3.png) center;
  background-size: cover;
}

.sect3 .sectTit {
  width: 520px;
  margin: auto;
  padding: 10px 20px;
  box-sizing: border-box;
  border-radius: 50px;
  letter-spacing: 2px;
  text-align: center;
  font-size: 36px;
  color: #fff;
  background: #E99776;;
}

.sect3 p {
  line-height: 2em;
}

.sect3 .gallery {
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  border-radius: 30px;
  overflow: hidden;
}

.sect3 .gallery .left {
  flex: 0 0 39%;  
}

.sect3 .gallery .left .imgContainer3-1 {
  width: 100%;
  margin: 0 0 10px;
  background: url(@/assets/socialTribe/pic3_01.jpg) center;
  background-size: cover;
}

.sect3 .gallery .left .imgContainer3-2 {
  width: 100%;
  margin: 0 0 10px;
  background: url(@/assets/socialTribe/pic3_02.jpg) center;
  background-size: cover;
}

.sect3 .gallery .left .imgContainer3-3 {
  width: 100%;
  background: url(@/assets/socialTribe/pic3_03.jpg) center;
  background-size: cover;
}

.sect3 .gallery .right {
  flex: 0 0 60%;
}

.sect3 .gallery .right .imgContainer3-4 {
  width: 100%;
  margin:  0 0 10px;
  background: url(@/assets/socialTribe/pic3_04.jpg) center;
  background-size: cover;
}

.sect3 .gallery .right .imgContainer3-5 {
  width: 49.2%;
  margin: 0 10px 0 0;
  display: inline-block;
  background: url(@/assets/socialTribe/pic3_05.jpg) center;
  background-size: cover;
}

.sect3 .gallery .right .imgContainer3-6 {
  width: 49.2%;
  display: inline-block;
  background: url(@/assets/socialTribe/pic3_06.jpg) center;
  background-size: cover;
}

@media screen and (min-width: 1367px) and (max-width: 1600px) {
  .kv .caption h1 {
    font-size: 48px;
  }
}

@media screen and (min-width: 1201px) and (max-width: 1366px) {
  .kv .caption h1 {
    font-size: 44px;
  }
}

@media screen and (min-width: 768px) and (max-width: 1200px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 40px;
  }

  .sect3 .gallery .right .imgContainer3-5 {
    width: 49.4%;
    margin: 0 5px 0 0;
  }

  .sect3 .gallery .right .imgContainer3-6 {
    width: 49.4%;
  }
}

@media screen and (min-width: 1px) and (max-width: 767px) {
  .kv .caption {
    width: 100%;
    padding: 10px 10px;
  }

  .kv .caption h1 {
    font-size: 24px;
    text-shadow: 3px 3px 3px #00000066;
  }

  .sect1 .gallery .left {
    flex: 0 0 100%;
  }

  .sect1 .gallery .right {
    flex: 0 0 100%;
  }

  .sect1 .gallery .left .imgContainer1-1 {
    margin: 0 0 5px;
  }

  .sect2 .sectTit {
    width: 160px;
    padding: 10px;
    top: -25px;
    font-size: 20px;
  }

  .sect2 .gallery .left {
    flex: 0 0 100%;
  }

  .sect2 .gallery .middle {
    flex: 0 0 100%;
    margin: 10px 0;
  }

  .sect2 .gallery .right {
    flex: 0 0 100%;
  }

  .sect3 .sectTit {
    width: 300px;
    font-size: 20px;
  }

  .sect3 .gallery .left {
    flex: 0 0 100%;
  }

  .sect3 .gallery .left .imgContainer3-1 {
    margin: 0 0 5px;
  }

  .sect3 .gallery .left .imgContainer3-2 {
    margin: 0 0 5px;
  }

  .sect3 .gallery .left .imgContainer3-3 {
    margin: 0 0 5px;
  }

  .sect3 .gallery .right {
    flex: 0 0 100%;
  }

  .sect3 .gallery .right .imgContainer3-4 {
    margin: 0 0 5px;
  }

  .sect3 .gallery .right .imgContainer3-5 {
    width: 100%;
    margin: 0 0 5px;
  }

  .sect3 .gallery .right .imgContainer3-6 {
    width: 100%;
  }
}
</style>
